/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InsuredResponseDto } from './InsuredResponseDto';
import {
    InsuredResponseDtoFromJSON,
    InsuredResponseDtoFromJSONTyped,
    InsuredResponseDtoToJSON,
    InsuredResponseDtoToJSONTyped,
} from './InsuredResponseDto';
import type { ReinsuredResponseDto } from './ReinsuredResponseDto';
import {
    ReinsuredResponseDtoFromJSON,
    ReinsuredResponseDtoFromJSONTyped,
    ReinsuredResponseDtoToJSON,
    ReinsuredResponseDtoToJSONTyped,
} from './ReinsuredResponseDto';
import type { BankAccountResponseDto } from './BankAccountResponseDto';
import {
    BankAccountResponseDtoFromJSON,
    BankAccountResponseDtoFromJSONTyped,
    BankAccountResponseDtoToJSON,
    BankAccountResponseDtoToJSONTyped,
} from './BankAccountResponseDto';
import type { BrokerResponseDto } from './BrokerResponseDto';
import {
    BrokerResponseDtoFromJSON,
    BrokerResponseDtoFromJSONTyped,
    BrokerResponseDtoToJSON,
    BrokerResponseDtoToJSONTyped,
} from './BrokerResponseDto';
import type { BinderResponseDto } from './BinderResponseDto';
import {
    BinderResponseDtoFromJSON,
    BinderResponseDtoFromJSONTyped,
    BinderResponseDtoToJSON,
    BinderResponseDtoToJSONTyped,
} from './BinderResponseDto';

/**
 * 
 * @export
 * @interface ClaimPaymentResponseDto
 */
export interface ClaimPaymentResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ClaimPaymentResponseDto
     */
    claimPaymentId: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimPaymentResponseDto
     */
    claimId: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimPaymentResponseDto
     */
    contractId: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimPaymentResponseDto
     */
    transactionType: ClaimPaymentResponseDtoTransactionTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof ClaimPaymentResponseDto
     */
    transactionDate: Date;
    /**
     * 
     * @type {string}
     * @memberof ClaimPaymentResponseDto
     */
    transactionId: string;
    /**
     * 
     * @type {Date}
     * @memberof ClaimPaymentResponseDto
     */
    paidDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ClaimPaymentResponseDto
     */
    paymentStatus: ClaimPaymentResponseDtoPaymentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ClaimPaymentResponseDto
     */
    payeeAccountName: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimPaymentResponseDto
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimPaymentResponseDto
     */
    accountNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimPaymentResponseDto
     */
    swiftCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimPaymentResponseDto
     */
    receivingPartyCurrency: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimPaymentResponseDto
     */
    originalCurrencyExchangeRate: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimPaymentResponseDto
     */
    settlementCurrency: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimPaymentResponseDto
     */
    settlementExchangeRate: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimPaymentResponseDto
     */
    claimsPaymentSource: ClaimPaymentResponseDtoClaimsPaymentSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof ClaimPaymentResponseDto
     */
    premiumBordereauxMonth?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimPaymentResponseDto
     */
    bankAccountNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimPaymentResponseDto
     */
    thisPaymentOurShare?: string;
    /**
     * 
     * @type {InsuredResponseDto}
     * @memberof ClaimPaymentResponseDto
     */
    insured?: InsuredResponseDto;
    /**
     * 
     * @type {BinderResponseDto}
     * @memberof ClaimPaymentResponseDto
     */
    binder?: BinderResponseDto;
    /**
     * 
     * @type {ReinsuredResponseDto}
     * @memberof ClaimPaymentResponseDto
     */
    reinsured?: ReinsuredResponseDto;
    /**
     * 
     * @type {BrokerResponseDto}
     * @memberof ClaimPaymentResponseDto
     */
    broker?: BrokerResponseDto;
    /**
     * 
     * @type {BankAccountResponseDto}
     * @memberof ClaimPaymentResponseDto
     */
    bankAccount?: BankAccountResponseDto;
}


/**
 * @export
 */
export const ClaimPaymentResponseDtoTransactionTypeEnum = {
    Payment: 'Payment',
    ReserveChangeOnly: 'Reserve Change Only'
} as const;
export type ClaimPaymentResponseDtoTransactionTypeEnum = typeof ClaimPaymentResponseDtoTransactionTypeEnum[keyof typeof ClaimPaymentResponseDtoTransactionTypeEnum];

/**
 * @export
 */
export const ClaimPaymentResponseDtoPaymentStatusEnum = {
    AwaitingApproval: 'Awaiting Approval',
    Approved: 'Approved',
    NotApproved: 'Not Approved',
    Paid: 'Paid'
} as const;
export type ClaimPaymentResponseDtoPaymentStatusEnum = typeof ClaimPaymentResponseDtoPaymentStatusEnum[keyof typeof ClaimPaymentResponseDtoPaymentStatusEnum];

/**
 * @export
 */
export const ClaimPaymentResponseDtoClaimsPaymentSourceEnum = {
    Float: 'Float',
    Premium: 'Premium',
    CashCall: 'Cash Call'
} as const;
export type ClaimPaymentResponseDtoClaimsPaymentSourceEnum = typeof ClaimPaymentResponseDtoClaimsPaymentSourceEnum[keyof typeof ClaimPaymentResponseDtoClaimsPaymentSourceEnum];


/**
 * Check if a given object implements the ClaimPaymentResponseDto interface.
 */
export function instanceOfClaimPaymentResponseDto(value: object): value is ClaimPaymentResponseDto {
    if (!('claimPaymentId' in value) || value['claimPaymentId'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('contractId' in value) || value['contractId'] === undefined) return false;
    if (!('transactionType' in value) || value['transactionType'] === undefined) return false;
    if (!('transactionDate' in value) || value['transactionDate'] === undefined) return false;
    if (!('transactionId' in value) || value['transactionId'] === undefined) return false;
    if (!('paymentStatus' in value) || value['paymentStatus'] === undefined) return false;
    if (!('payeeAccountName' in value) || value['payeeAccountName'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('receivingPartyCurrency' in value) || value['receivingPartyCurrency'] === undefined) return false;
    if (!('originalCurrencyExchangeRate' in value) || value['originalCurrencyExchangeRate'] === undefined) return false;
    if (!('settlementCurrency' in value) || value['settlementCurrency'] === undefined) return false;
    if (!('settlementExchangeRate' in value) || value['settlementExchangeRate'] === undefined) return false;
    if (!('claimsPaymentSource' in value) || value['claimsPaymentSource'] === undefined) return false;
    if (!('bankAccountNumber' in value) || value['bankAccountNumber'] === undefined) return false;
    return true;
}

export function ClaimPaymentResponseDtoFromJSON(json: any): ClaimPaymentResponseDto {
    return ClaimPaymentResponseDtoFromJSONTyped(json, false);
}

export function ClaimPaymentResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimPaymentResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claimPaymentId': json['claimPaymentId'],
        'claimId': json['claimId'],
        'contractId': json['contractId'],
        'transactionType': json['transactionType'],
        'transactionDate': (new Date(json['transactionDate'])),
        'transactionId': json['transactionId'],
        'paidDate': json['paidDate'] == null ? undefined : (new Date(json['paidDate'])),
        'paymentStatus': json['paymentStatus'],
        'payeeAccountName': json['payeeAccountName'],
        'country': json['country'],
        'accountNumber': json['accountNumber'] == null ? undefined : json['accountNumber'],
        'swiftCode': json['swiftCode'] == null ? undefined : json['swiftCode'],
        'receivingPartyCurrency': json['receivingPartyCurrency'],
        'originalCurrencyExchangeRate': json['originalCurrencyExchangeRate'],
        'settlementCurrency': json['settlementCurrency'],
        'settlementExchangeRate': json['settlementExchangeRate'],
        'claimsPaymentSource': json['claimsPaymentSource'],
        'premiumBordereauxMonth': json['premiumBordereauxMonth'] == null ? undefined : json['premiumBordereauxMonth'],
        'bankAccountNumber': json['bankAccountNumber'],
        'thisPaymentOurShare': json['thisPaymentOurShare'] == null ? undefined : json['thisPaymentOurShare'],
        'insured': json['insured'] == null ? undefined : InsuredResponseDtoFromJSON(json['insured']),
        'binder': json['binder'] == null ? undefined : BinderResponseDtoFromJSON(json['binder']),
        'reinsured': json['reinsured'] == null ? undefined : ReinsuredResponseDtoFromJSON(json['reinsured']),
        'broker': json['broker'] == null ? undefined : BrokerResponseDtoFromJSON(json['broker']),
        'bankAccount': json['bankAccount'] == null ? undefined : BankAccountResponseDtoFromJSON(json['bankAccount']),
    };
}

export function ClaimPaymentResponseDtoToJSON(json: any): ClaimPaymentResponseDto {
    return ClaimPaymentResponseDtoToJSONTyped(json, false);
}

export function ClaimPaymentResponseDtoToJSONTyped(value?: ClaimPaymentResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimPaymentId': value['claimPaymentId'],
        'claimId': value['claimId'],
        'contractId': value['contractId'],
        'transactionType': value['transactionType'],
        'transactionDate': ((value['transactionDate']).toISOString()),
        'transactionId': value['transactionId'],
        'paidDate': value['paidDate'] == null ? undefined : ((value['paidDate']).toISOString()),
        'paymentStatus': value['paymentStatus'],
        'payeeAccountName': value['payeeAccountName'],
        'country': value['country'],
        'accountNumber': value['accountNumber'],
        'swiftCode': value['swiftCode'],
        'receivingPartyCurrency': value['receivingPartyCurrency'],
        'originalCurrencyExchangeRate': value['originalCurrencyExchangeRate'],
        'settlementCurrency': value['settlementCurrency'],
        'settlementExchangeRate': value['settlementExchangeRate'],
        'claimsPaymentSource': value['claimsPaymentSource'],
        'premiumBordereauxMonth': value['premiumBordereauxMonth'],
        'bankAccountNumber': value['bankAccountNumber'],
        'thisPaymentOurShare': value['thisPaymentOurShare'],
        'insured': InsuredResponseDtoToJSON(value['insured']),
        'binder': BinderResponseDtoToJSON(value['binder']),
        'reinsured': ReinsuredResponseDtoToJSON(value['reinsured']),
        'broker': BrokerResponseDtoToJSON(value['broker']),
        'bankAccount': BankAccountResponseDtoToJSON(value['bankAccount']),
    };
}

